/* collection-carousel.js — scroll buttons + disabled state for collection list.
   Vanilla, no globals. Degrades gracefully without JS (native overflow scroll). */

class CollectionCarousel extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-carousel-viewport]');
    this.track = this.querySelector('[data-carousel-track]');
    this.prevBtn = this.querySelector('[data-carousel-prev]');
    this.nextBtn = this.querySelector('[data-carousel-next]');
    if (!this.viewport || !this.track) return;

    this.onScroll = this.onScroll.bind(this);
    this.onPrev = this.onPrev.bind(this);
    this.onNext = this.onNext.bind(this);

    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
    if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

    this.updateButtons();
  }

  disconnectedCallback() {
    if (this.viewport) this.viewport.removeEventListener('scroll', this.onScroll);
    if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
    if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
  }

  onScroll() { this.updateButtons(); }

  onPrev() {
    this.viewport.scrollBy({ left: -this.viewport.clientWidth * 0.8, behavior: 'smooth' });
  }

  onNext() {
    this.viewport.scrollBy({ left: this.viewport.clientWidth * 0.8, behavior: 'smooth' });
  }

  updateButtons() {
    if (!this.prevBtn || !this.nextBtn) return;
    var maxScroll = this.track.scrollWidth - this.viewport.clientWidth;
    var scrolled = this.viewport.scrollLeft;
    this.prevBtn.disabled = scrolled <= 2;
    this.nextBtn.disabled = scrolled >= maxScroll - 2;
  }
}

if (!customElements.get('collection-carousel')) {
  customElements.define('collection-carousel', CollectionCarousel);
}
